import React, { useState } from 'react'

const initialData = [
    ["A", "B", "C", "D"],
    [1, 2, 3, 4],
    [5, 6, 7, 8],
    [9, 10, 11, 12]
  ];

const ModalDiligenciarRecordAnestesia = ({setmodalOnDiligenciarRecordAnestesia,dataUserDiligenciar}) => {
    const handleCancelClick=()=>{
        setmodalOnDiligenciarRecordAnestesia(false)
    }
    const [formState, setFormState] = useState({
        nombre: '',
        email: '',
        opcion: '',
        sexo: ''
      });
    
      const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormState({
          ...formState,
          [name]: value
        });
      };
    
      const handleSubmit = (e) => {
        e.preventDefault();
        // Lógica de envío del formulario
        console.log(formState);
      };
      /////////////////////CUADRICULA//////////////////////
      // Define el estado para los datos y la celda que se está editando
      const [data, setData] = useState(initialData);
  const [editing, setEditing] = useState(null);
  const handleDoubleClick = (rowIndex, cellIndex) => {
    setEditing({ rowIndex, cellIndex });
  };
  
  const handleChange = (event, rowIndex, cellIndex) => {
    const newData = data.slice();
    newData[rowIndex][cellIndex] = event.target.value;
    setData(newData);
  };
  
  const handleBlur = () => {
    setEditing(null);
  };

    //////////////////////FIN/////////////////////////
    /////////////RIESGO///////////////
    const [riesgo, setRiesgo] = useState('');
    const handleChangeRiesgo = (event) => {
        setRiesgo(event.target.value);
      };
  return (
    <>
    
        <div className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
    id="exampleModalScrollable" tabIndex="-1" aria-labelledby="exampleModalScrollableLabel" aria-hidden="true">
    <div className="sm:h-[calc(100%)]  mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current ">
        
        <div className="flex flex-shrink-0 items-center justify-between p-1 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
        <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
               Diligenciar Record Anestesia
            </h5>
           
            {/* <ul
            className="flex mb-0 list-none flex-wrap pt-3 pb-2 flex-row"
            role="tablist"
          >
            <li className="-mb-px mr-2 last:mr-0 flex-auto text-center">
              <a
                className={
                  "text-xs font-bold uppercase px-3 py-2 shadow-lg rounded block leading-normal " +
                  (openTab === 1
                    ? "text-white bg-" + color + "-600"
                    : "text-" + color + "-600 bg-white")
                }
                onClick={e => {
                  e.preventDefault();
                  setOpenTab(1);
                }}
                data-toggle="tab"
                href="#link1"
                role="tablist"
              >
                Cirugía
              </a>
            </li>
            <li className="-mb-px mr-2 last:mr-0 flex-auto text-center">
              <a
                className={
                  "text-xs font-bold uppercase px-3 py-2 shadow-lg rounded block leading-normal " +
                  (openTab === 2
                    ? "text-white bg-" + color + "-600"
                    : "text-" + color + "-600 bg-white")
                }
                onClick={e => {
                  e.preventDefault();
                  setOpenTab(2);
                }}
                data-toggle="tab"
                href="#link2"
                role="tablist"
              >
                 Procedimiento
              </a>
            </li>
            
          </ul> */}
            <button type="button"
            onClick={handleCancelClick}
            className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
            data-bs-dismiss="modal" aria-label="Close">X</button>
        </div>
        <div className="flex-auto overflow-y-auto relative ">
        <form  >
        <div className="flex-auto overflow-y-auto relative p-2 text-center">
        <div className="bg-[#05a29d] mt-3">
                <label className="form-label inline-block mb-2 text-white font-medium text-center text-xl">
                Datos Paciente
                </label>
              </div>
              <div className="flex py-2 text-left">
                                <div className="w-1/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        N° Documento
                                    </label>
                                    <input
                                        
                                        defaultValue={dataUserDiligenciar.MPCedu}
                                        disabled={true}
                                        type="text"
                                        name='numeroDocumento'
                                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                    />
                                </div>
                                <div className="w-1/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                    Tipo Documento
                                    </label>
                                    <input
                                        //   onChange={searchUserId}
                                        //defaultValue={props.userDate[0].ProEmpCod}
                                        defaultValue={dataUserDiligenciar.MPTDoc}
                                        disabled={true}
                                        type="text"
                                        name = 'tipoDocumento'
                                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                    />
                                </div>
                                <div className="w-2/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Nombre del Paciente
                                    </label>
                                    <input
                                        
                                        defaultValue={dataUserDiligenciar.MPNOMC}
                                        disabled={true}
                                        type="text"
                                        name='nombrePaciente'
                                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                    />
                                </div>
                                
                                <div className="w-1/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Edad
                                    </label>
                                    <div className="flex">
                                        <input
                                            //   onChange={searchUserId}
                                            //defaultValue={props.userDate[0].ProEmpCod}
                                            //defaultValue={edadPaciente}
                                            disabled={true}
                                            type="number"
                                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                            id="exampleFormControlInput1"
                                            placeholder=""
                                        />
                                        <label className="px-2"></label>
                                        <input
                                            //   onChange={searchUserId}
                                            //defaultValue={props.userDate[0].ProEmpCod}
                                            //defaultValue={years}
                                            disabled={true}
                                            type="text"
                                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                            id="exampleFormControlInput1"
                                            placeholder=""
                                        />
                                    </div>
                                </div>
            </div>
            {/* <div className="flex flex-row   text-left">
                                <div className="w-1/5  px-1 ">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium " >
                                        Cama
                                    </label>
                                    <input
                                        
                                        //defaultValue={dataUserDiligenciar.MPNOMC}
                                        //autoComplete='off'
                                        name="empresa"
                                        
                                        disabled={true}
                                        
                                        type="text"
                                        className="form-control block w-full px-1 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                    />
                                </div>
                                <div className="w-1/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Sala o Cuarto
                                    </label>
                                    <input
                                        //   onChange={searchUserId}
                                        //defaultValue={dataUserDiligenciar.MPCedu}
                                        //defaultValue={dataUser.ProMCDpto? dataUser.ProMCDpto:null}
                                        //disabled={true}
                                        // {...register('ProCSede')}
                                        type="text"
                                        name = 'sede'
                                        className="form-control block w-full px-1 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                    />
                                </div>
                                <div className="w-1/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Proceso
                                    </label>
                                    <input
                                        //   onChange={searchUserId}
                                        //defaultValue={props.userDate[0].ProEmpCod}
                                        //defaultValue={dataUser.ProCirCod?dataUser.ProCirCod:null}
                                        //disabled={true}
                                        type="text"
                                        name = 'nCirugia'
                                        className="form-control block w-full px-1 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                    />
                                </div>
                                <div className="w-1/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Sexo
                                    </label>
                                    <input
                                        //   onChange={searchUserId}
                                        //defaultValue={props.userDate[0].ProEmpCod}
                                        //defaultValue={dataUser.ProCirAut?dataUser.ProCirAut:null}
                                        type="text"
                                        name = 'nAutorizacion'
                                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                    />
                                </div>
                                <div className="w-1/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Peso
                                    </label>
                                    <input
                                        //   onChange={searchUserId}
                                        //defaultValue={props.userDate[0].ProEmpCod}
                                        //defaultValue={props.userDate.ProEmpCod}
                                        //defaultValue={dataEstados}
                                        //disabled={true}
                                        type="text"
                                        name = 'estadoPaciente'
                                        className="form-control block w-full px-1 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                    />
                                </div>
            </div> */}
            
            {/* <div className="flex py-2 text-left">
                                <div className="w-1/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                    Temperatura 
                                    </label>
                                    <input
                                        //   onChange={searchUserId}
                                        //defaultValue={props.userDate[0].ProEmpCod}
                                        //onFocus={cirugiaQuirofano}
                                        //defaultValue={dataUser.ProCons}
                                        //defaultValue={dataChildQuirofano.codigoQuirofano?dataChildQuirofano.codigoQuirofano:null}
                                        name = 'nQuirofano'
                                        //onChange={(e) => console.log(e.target.nQuirofano.value)}
                                        type="text"
                                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                        readOnly
                                    />
                                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                                       
                                    </label>
                                </div>
                                <div className="w-2/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                    Quirófano
                                    </label>
                                    <input
                                        //   onChange={searchUserId}
                                        //defaultValue={props.userDate[0].ProEmpCod}
                                        //defaultValue={dataUser.ProNcons}
                                        //defaultValue={dataChildQuirofano.descripcionQuirofano?dataChildQuirofano.descripcionQuirofano:null}
                                        disabled={true}
                                        type="text"
                                        name='nombreQuirofano'
                                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                    />
                                </div>
                                <div className="w-1/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Sede Quirófano
                                    </label>
                                    <input
                                        //   onChange={searchUserId}
                                        //defaultValue={props.userDate[0].ProEmpCod}
                                        //defaultValue={props.userDate.ProEmpCod}
                                        //defaultValue={dataUser.ProSedQr}
                                        //defaultValue={dataChildQuirofano.sedeQuirofano}
                                        disabled={true}
                                        type="text"
                                        name = 'sedeQuirofano'
                                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                    />
                                </div>
                                <div className="w-1/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Indi. Oportunidad
                                    </label>
                                    <input
                                        //   onChange={searchUserId}
                                        //defaultValue={props.userDate[0].ProEmpCod}
                                        //defaultValue={props.userDate.ProEmpCod} 
                                        //defaultValue={dataUser.ProIndOpu}
                                        type="number"
                                        name = 'indOportunidad'
                                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                    />
                                </div>
            </div> */}
            
            {/* <div className="flex  text-left">
                                <div className="w-1/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Fecha Inicial
                                    </label>
                                    <input
                                        //   onChange={searchUserId}
                                        //value={fechaI}
                                        //disabled={true}
                                        //onChange={handleOnchangeFechaInicial}
                                        //defaultValue={fechaActual()}
                                        type="date"
                                        name = 'fechaInicial'
                                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                    />
                                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                                        
                                    </label>
                                    
                                </div>
                                <div className="w-1/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                    Hora Inicial
                                    </label>
                                    <input
                                        //   onChange={searchUserId}
                                        //defaultValue={props.userDate[0].ProEmpCod}
                                        //defaultValue={dataUser.ProHorI}
                                        //value={horaI}
                                        //onChange={handleOnchangeHoraInicial}
                                        type="time"
                                        name = 'horaInicial'
                                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                    />
                                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                                        
                                    </label>
                                </div>
                                <div className="w-1/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Fecha Final
                                    </label>
                                    <input
                                        //   onChange={searchUserId}
                                        //defaultValue={fechaActual()}
                                        //value={fechaF}
                                        //onChange={handleOnchangeFechaFinal}
                                        type="date"
                                        name='fechaFinal'
                                        //disabled={true}
                                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                    />
                                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                                        
                                    </label>
                                </div>
                                <div className="w-1/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Hora Final
                                    </label>
                                    <input
                                        //   onChange={searchUserId}
                                        //defaultValue={props.userDate[0].ProEmpCod}
                                        //defaultValue={dataUser.ProHorF}
                                        //value={horaF}
                                        //onChange={handleOnchangeHoraFinal}
                                        type="time"
                                        name = 'horaFinal'
                                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                    />
                                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                                       
                                    </label>
                                </div>
                                <div className="w-1/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Duración
                                    </label>
                                    <div className="flex">
                                        <input
                                            
                                            //defaultValue={dataUser.ProDurHr}
                                            //defaultValue={calcularDuracionHora}
                                            disabled={true}
                                            type="number"
                                            name = 'horaDuracion'
                                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                            id="exampleFormControlInput1"
                                            placeholder="HH"
                                        />
                                        <label className="pt-1 px-2">:</label>
                                        <input
                                            
                                            //defaultValue={dataUser.ProDurMn}
                                            //defaultValue={calcularDurarionMinutos}
                                            disabled={true}
                                            type="number"
                                            name='minutoDuracion'
                                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                            id="exampleFormControlInput1"
                                            placeholder="MM"
                                        />
                                    </div>
                                </div>
            </div> */}
            {/* <div className="flex  text-left">
                                <div className="w-2/5  px-1">
                                <div className="flex flex-col items-center">
            
            <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
            Riesgo seleccionado: {riesgo}
                                    </label>
      <form className="flex space-x-4">
        { [1, 2, 3, 4, 5].map((nivel) => (
          <label key={nivel} className="flex items-center">
            <input
              type="radio"
              value={nivel}
              checked={riesgo == nivel}
              onChange={handleChangeRiesgo}
              className="form-radio text-blue-500"
            />
            <span className="ml-2 text-gray-700">{nivel}</span>
          </label>
        )) }
      </form>
      
    </div>
                                    
                                </div>
                                <div className="w-1/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                    Hora Inicial
                                    </label>
                                    <input
                                        //   onChange={searchUserId}
                                        //defaultValue={props.userDate[0].ProEmpCod}
                                        //defaultValue={dataUser.ProHorI}
                                        //value={horaI}
                                        //onChange={handleOnchangeHoraInicial}
                                        type="time"
                                        name = 'horaInicial'
                                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                    />
                                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                                       
                                    </label>
                                </div>
                                <div className="w-1/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Fecha Final
                                    </label>
                                    <input
                                        //   onChange={searchUserId}
                                        //defaultValue={fechaActual()}
                                        //value={fechaF}
                                        //onChange={handleOnchangeFechaFinal}
                                        type="date"
                                        name='fechaFinal'
                                        //disabled={true}
                                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                    />
                                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                                        
                                    </label>
                                </div>
                                <div className="w-1/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Hora Final
                                    </label>
                                    <input
                                        //   onChange={searchUserId}
                                        //defaultValue={props.userDate[0].ProEmpCod}
                                        //defaultValue={dataUser.ProHorF}
                                        //value={horaF}
                                        //onChange={handleOnchangeHoraFinal}
                                        type="time"
                                        name = 'horaFinal'
                                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                    />
                                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                                       
                                    </label>
                                </div>
                                
            </div> */}
           
            {/* <div className="container mx-auto p-4">
    <table className="min-w-full bg-white">
      <tbody>
        {data.map((row, rowIndex) => (
          <tr key={rowIndex}>
            {row.map((cell, cellIndex) => (
              <td
                key={cellIndex}
                className="border px-4 py-2"
                onDoubleClick={() => handleDoubleClick(rowIndex, cellIndex)}
              >
                {editing && editing.rowIndex === rowIndex && editing.cellIndex === cellIndex ? (
                  <input
                    type="text"
                    value={cell}
                    onChange={(event) => handleChange(event, rowIndex, cellIndex)}
                    onBlur={handleBlur}
                    autoFocus
                  />
                ) : (
                  cell
                )}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div> */}
            {/* <div className="flex py-2 text-left">
                                <div className="w-1/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        N° Documento
                                    </label>
                                    <input
                                        
                                        disabled={true}
                                        type="text"
                                        name='numeroDocumento'
                                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                    />
                                </div>
                                <div className="w-1/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                    Tipo Documento
                                    </label>
                                    <input
                                        //   onChange={searchUserId}
                                        //defaultValue={props.userDate[0].ProEmpCod}
                                        //defaultValue={dataUser.MPTDoc}
                                        disabled={true}
                                        type="text"
                                        name = 'tipoDocumento'
                                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                    />
                                </div>
                                <div className="w-2/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Nombre del Paciente
                                    </label>
                                    <input
                                        //   onChange={searchUserId}
                                        //defaultValue={props.userDate[0].ProEmpCod}
                                        //defaultValue={dataUser.MPNOMC}
                                        disabled={true}
                                        type="text"
                                        name='nombrePaciente'
                                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                    />
                                </div>
                                
                                <div className="w-1/5  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Edad
                                    </label>
                                    <div className="flex">
                                        <input
                                            //   onChange={searchUserId}
                                            //defaultValue={props.userDate[0].ProEmpCod}
                                            //defaultValue={edadPaciente}
                                            disabled={true}
                                            type="number"
                                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                            id="exampleFormControlInput1"
                                            placeholder=""
                                        />
                                        <label className="px-2"></label>
                                        <input
                                            //   onChange={searchUserId}
                                            //defaultValue={props.userDate[0].ProEmpCod}
                                            //defaultValue={years}
                                            disabled={true}
                                            type="text"
                                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                            id="exampleFormControlInput1"
                                            placeholder=""
                                        />
                                    </div>
                                </div>
            </div> */}
            {/* <div  className="w-1/2 py-2 text-left px-1">
                <label  className="form-label inline-block mb-2 text-gray-900 font-medium " >
                     Opción
                </label>
                <select className="form-select block  w-full px-2 py-0.5 text-base font-normal text-gray-700 bg-[#eaebec] bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" aria-label="Default select example " 
                //defaultValue={dataUser.ProSit}
                //value={opcion}
                //onChange={handleOnchangeOpcion} 
                >
                                        <option value="0">Sin seleccionar</option>
                                        <option value="1">PROGRAMADA</option>
                                        <option value="2">URGENCIAS</option>                                        
                                    </select>
                                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                                        {opcionUserError}
                                    </label>
            </div> */}
            {/* <div className="flex py-1 text-left">
                                <div className="w-1/2  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Reservado Por
                                    </label>
                                    <div className="flex">
                                        <input
                                            //   onChange={searchUserId}
                                            //defaultValue={props.userDate[0].ProEmpCod}
                                            //defaultValue={props.userDate.ProEmpCod}
                                            //onFocus={cirugiaReservadoPor}
                                            //defaultValue={dataUser.ProPerSep}
                                            //defaultValue={dataChildReservadorPor.codigoMedicoEs}
                                            type="text"
                                            name = 'coReservadoPor'
                                            autoComplete='off'
                                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec]  bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                            id="exampleFormControlInput1"
                                            placeholder=""
                                            readOnly
                                        />
                                        <label className="px-2"></label>
                                        <input
                                            //   onChange={searchUserId}
                                            //defaultValue={props.userDate[0].ProEmpCod}
                                            //defaultValue={props.userDate.ProEmpCod}
                                            //disabled={true}
                                            //defaultValue={dataChildReservadorPor.nombreMedicoEs}
                                            type="text"
                                            name='nombreReservadoPor'
                                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                            id="exampleFormControlInput1"
                                            placeholder=""
                                        />
                                    </div>
                                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                                            {errorReservadoPor}
                                        </label>
                                </div>
                                <div className="w-1/2  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Especialidad
                                    </label>
                                    <div className="flex">
                                        <input
                                            //   onChange={searchUserId}
                                            //defaultValue={props.userDate[0].ProEmpCod}
                                            //defaultValue={props.userDate.ProEmpCod}
                                            //defaultValue={dataUser.ProEspSep}
                                            //defaultValue={dataChildReservadorPor.codigoEspecialidad}
                                            //onFocus={cirugiaReservadoPorEspecialidad}
                                            type="text"
                                            name = 'reservadoPorEspecialidad'
                                            autoComplete='off'
                                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                            id="exampleFormControlInput1"
                                            placeholder=""
                                            readOnly
                                        />
                                        <label className="px-2"></label>
                                        <input
                                            //   onChange={searchUserId}
                                            //defaultValue={props.userDate[0].ProEmpCod}
                                            //defaultValue={props.userDate.ProEmpCod}dataChildReservadoPorEspecialidad       
                                            //defaultValue={dataChildReservadorPor.nombreEspecialidad}
                                            type="text"
                                            disabled={true}
                                            name='nombreReservadoPorEspecialidad'
                                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                            id="exampleFormControlInput1"
                                            placeholder=""
                                        />
                                    </div>
                                </div>
                                
                                
                                
                                
            </div> */}
            {/* <div className="flex py-1 text-left">
                                <div className="w-1/2  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Cirujano a Cargo
                                    </label>
                                    <div className="flex">
                                        <input
                                            //   onChange={searchUserId}
                                            //defaultValue={props.userDate[0].ProEmpCod}
                                            //defaultValue={props.userDate.ProEmpCod}
                                            //onFocus={cirujanoACargo}
                                            //defaultValue={dataUser.ProPerSe1}
                                            //defaultValue={dataChildCirujanoACargo.codigoMedicoEs}
                                            autoComplete='off'
                                            type="text"
                                            name='codigoCirujanoCargo'
                                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                            id="exampleFormControlInput1"
                                            placeholder=""
                                            readOnly
                                        />
                                        
                                        <label className="px-2"></label>
                                        <input
                                            //   onChange={searchUserId}
                                            //defaultValue={props.userDate[0].ProEmpCod}
                                            //defaultValue={props.userDate.ProEmpCod}dataChildCirujanoACargo.nombreMedicoEs
                                            //defaultValue={dataChildCirujanoACargo.nombreMedicoEs}
                                            type="text"
                                            name='nombreCirujanoCargo'
                                            disabled={true}
                                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                            id="exampleFormControlInput1"
                                            placeholder=""
                                        />
                                    </div>
                                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                                            {codigoCirujanoCargoUserError}
                                        </label>
                                </div>
                                <div className="w-1/2  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Especialidad
                                    </label>
                                    <div className="flex">
                                        <input
                                            //   onChange={searchUserId}
                                            //defaultValue={props.userDate[0].ProEmpCod}
                                            //defaultValue={dataUser.ProDxppal}
                                            type="text"
                                            name='codigoCirujanoCargoEspecialidad'
                                            //defaultValue={dataUser.ProEspSe1}
                                            //defaultValue={dataChildCirujanoACargo.codigoEspecialidad}
                                            //onFocus={cirugiaCirujanoCargoEspecialidad}
                                            autoComplete='off'
                                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                            id="exampleFormControlInput1"
                                            placeholder=""
                                            readOnly
                                        />
                                        <label className="px-2"></label>
                                        <input
                                            //   onChange={searchUserId}
                                            //defaultValue={props.userDate[0].ProEmpCod}
                                            //defaultValue={dataUser.ProDN1}
                                            //defaultValue={dataChildCirujanoACargo.nombreEspecialidad}
                                            type="text"
                                            name = 'nombreCirujanoCargoEspecialidad'
                                            disabled={true}
                                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                            id="exampleFormControlInput1"
                                            placeholder=""
                                        />
                                    </div>
                                </div>
            </div> */}
            {/* <div className="bg-[#05a29d] mt-3">
                <label className="form-label inline-block mb-2 text-white font-medium text-center text-2xl">
                Datos Preoperatorios
                </label>
              </div> */}
            
            {/* <div className="flex py-1 text-left">
                                <div className="w-full  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Entidad Aseguradora
                                    </label>
                                    <div className="flex">
                                        <input
                                            //   onChange={searchUserId}
                                            //defaultValue={props.userDate[0].ProEmpCod}
                                            //onFocus={cirugiaEntidadAseguradora}
                                            //defaultValue={dataChildEntidadAseguradora.MENNIT}
                                            type="text"
                                            name='nombreEPSEntidadAseguradora'
                                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                            id="exampleFormControlInput1"
                                            placeholder=""
                                            readOnly
                                        />
                                        <label className="px-2"></label>
                                        <input
                                            //   onChange={searchUserId}
                                            //defaultValue={props.userDate[0].ProEmpCod}
                                            //defaultValue={dataChildEntidadAseguradora.MENOMB}
                                            disabled={true}
                                            type="text"
                                            name='nEPS'
                                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                            id="exampleFormControlInput1"
                                            placeholder=""
                                        />
                                    </div>
                                </div>
                                
            </div> */}
            {/* <div className="flex py-2 text-left">
                                <div className="w-1/3  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Lateralidad
                                    </label>
                                    <select className="form-select block  w-full px-2 py-0.5 text-base font-normal text-gray-700 bg-[#eaebec] bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                    aria-label="Default select example" 
                                    //onChange={handleOnchangeLateralidad}
                                    //value={lateralidadUser}
                                    //value={dataUser.ProLat}
                                    name='lateralidad'>
                                        <option value=" ">Sin seleccionar</option>
                                        <option value="D">Derecho</option>
                                        <option value="I">Izquierdo</option>
                                        <option value="B">Bilateral</option>
                                        <option value="N">No aplica</option>
                                    </select>
                                </div>
                                <div className="w-1/3 px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Req Valoración Preanestésica?
                                    </label>
                                    <input className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" 
                                    type="checkbox" 
                                    name= 'valoracionPreanestesica'
                                    id="flexCheckDefault"
                                    //checked={reqValoracionPreanestesica}
                                    //onChange={handleOnchangeReqValoracionPreanestesica}
                                    />
                                </div>
                                <div className="w-1/3  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Tipo de Anestesia
                                    </label>
                                    <select className="form-select block  w-full px-2 py-0.5 text-base font-normal text-gray-700 bg-[#eaebec] bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                    aria-label="Default select example" 
                                    //name = 'tipoDeAnestesia'
                                   // value={tipoDeAnestesiaUser}
                                    //onChange = {handleOnchangeTipoDeAnestesia}
                                    >                                        
                                        <option value="1">GENERAL</option>
                                        <option value="2">LOCAL</option>
                                        <option value="3">EPIDURAL</option>
                                    </select>
                                </div>                          
            </div> */}
            {/* <div className="flex py-2 text-left">
                                <div className="w-1/3  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        Estado del Paciente
                                    </label>
                                    <select className="form-select block  w-full px-2 py-0.5 text-base font-normal text-gray-700 bg-[#eaebec] bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                                    aria-label="Default select example" 
                                    //onChange={handleOnchangeEstadoDelPaciente}
                                    //value={estadoDelPacienteUser}
                                    >
                                        <option value="0">Sin seleccionar</option>
                                        <option value="1">Vivo</option>
                                        <option value="2">Rescate</option>
                                        <option value="3">Cuidados intensivos</option>
                                        <option value="4">Conciente</option>
                                        <option value="5">Semiconciente</option>
                                        <option value="6">Inconciente</option>
                                    </select>
                                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                                            {estadoPacienteError}
                                    </label>
                                </div>
                                <div className="w-2/3  px-1">
                                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                        DX Preoperatorio
                                    </label>
                                    <div className="flex">
                                        <input
                                            //   onChange={searchUserId}
                                            //defaultValue={props.userDate[0].ProEmpCod}
                                            //defaultValue={dataUser.ProDxppal}
                                            //defaultValue={dataChildPreoperatorio.DMCodi}
                                            //onFocus={cirugiaDXPreoperatorio}
                                            type="text"
                                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                            id="exampleFormControlInput1"
                                            placeholder=""
                                            readOnly
                                        />
                                        <label className="px-2"></label>
                                        <input
                                            //   onChange={searchUserId}
                                            //defaultValue={props.userDate[0].ProEmpCod}
                                            //defaultValue={props.userDate.ProEmpCod}
                                            //defaultValue={dataUser.ProDN1}
                                            //defaultValue={dataChildPreoperatorio.DMNomb}
                                            disabled={true}
                                            type="text"
                                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                            id="exampleFormControlInput1"
                                            placeholder=""
                                        />
                                        
                                    </div>
                                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                                            {errorDxPreoperatorio}
                                    </label>
                                </div>
            </div> */}
            {/* <div className="bg-[#05a29d] mt-3">
                <label className="form-label inline-block mb-2 text-white font-medium text-center text-2xl">
                Preparación de la Cirugía:
                </label>
              </div> */}
            
            {/* <div className="flex px-1 py-1 text-left">
                <div className="w-1/3 ">
                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                        Reserva Cama? 
                    </label>
                    <input className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" 
                    type="checkbox" 
                    id="flexCheckDefault" 
                    //onChange={handleOnchangeReservaDeCama}
                    //checked={reservaCama}
                    />
                </div>
                <div className="w-1/3 px-1">
                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                        Req. Materiales Especiales?
                    </label>
                    <input className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="checkbox" id="flexCheckDefault" 
                    //onChange={handleOnchangeReqMateEspeciales}
                    //checked={reqMaterialesEspeciales}
                    />
                </div>
                <div className="w-1/3 ">
                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                        Req. Disp. Equipos Especiales?
                    </label>
                    <input className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="checkbox" id="flexCheckDefault" 
                    //onChange={handleOnchangeReqDispEquiposEspeciales}
                    //checked={reqDispEquiposEspeciales}
                    //defaultChecked={reqDispEquiposEspeciales}
                    />
                </div>
            </div> */}
            {/* <div className="flex px-1  text-left">
                <div className="w-1/3 ">
                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                        Tipo de Cama CX 
                    </label>
                    <select className="form-select block  w-full px-2 py-0.5 text-base font-normal text-gray-700 bg-[#eaebec] bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    aria-label="Default select example"
                     //value={tipoCamaDxUser} 
                    //onChange={handleOnchangeTipoDeCamaCX}
                     //disabled={!reservaCama}
                     >
                        <option value=" ">Sin seleccionar</option>
                        <option value="H">Hospitalización</option>
                        <option value="U">UCI</option>                    
                    </select>
                </div>
                <div className="w-1/3 px-1">    
                    <textarea
                    //onChange={handleOnchangeReqMaterialesEspecialesTextArea}
                    //value={reqDispEquiposEspecialesTextArea}
                    //disabled={!reqMaterialesEspeciales}
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-700  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300 rounded
                        transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    id="exampleFormControlTextarea1"
                    rows="3"
                    placeholder=""
                    ></textarea>
                </div>
                <div className="w-1/3">    
                    <textarea
                    //disabled={!reqDispEquiposEspeciales}
                    //onChange={handleOnchangeReqDispEquiposEspcialesUser}
                    //value={reqDispEquiposEspecialesUserTextArea}
                    //defaultValue={dataUser.ProObsEE}
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-700  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300 rounded
                        transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    id="exampleFormControlTextarea1"
                    rows="3"
                    placeholder=""
                    ></textarea>
                </div>
            </div> */}
            {/* <div className='px-1'>
                <div className="w-1/3 ">    
                    <textarea
                    //onChange={handleOnchangeTextAreaTipoDeCamaCx}
                    //value={tipoCamaCXTextAreaUser}
                    //defaultValue={dataUser.ProObRCam}
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-700  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300 rounded
                        transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    id="exampleFormControlTextarea1"
                    rows="3"
                    placeholder=""
                    ></textarea>
                </div>
            </div> */}
            {/* <div className='px-1 py-2 text-left'>
                <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                    Dieta:
                    {isChecked ? "checked" : "unchecked"}
                </label>
            </div> */}
            {/* <div className='flex'>            
                <div className='flex px-0.5  text-left w-1/3 '>
                    <div>
                        <div className="">
                            <label  className="form-label inline-block mb-1 text-gray-900 text-sm	" >
                                Ninguna
                            </label>
                            <input className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" 
                            type="checkbox" 
                            name='ningunaDieta'
                            //checked={isChecked}
                            //checked={isCheckedNinguna}
                            //onChange={handleOnChangeNinguna}
                            id="flexCheckDefault"/>
                        </div>
                        <div className="">
                            <label  className="form-label inline-block mb-1 text-gray-900 text-sm	" >
                                Blanda
                            </label>
                            <input className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="checkbox"
                            //onChange={handleOnchangeDieta}
                            //defaultValue={blanda}
                            //name='blanda'
                             id="flexCheckDefault"/>
                        </div>
                        <div className="">
                            <label  className="form-label inline-block mb-1 text-gray-900 text-sm	" >
                                Líquida
                            </label>
                            <input className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="checkbox"
                            //onChange={handleOnchangeDietaLiquida}
                            //defaultValue={liquida}
                             id="flexCheckDefault"/>
                        </div>
                        <div className="">
                            <label  className="form-label inline-block mb-1 text-gray-900 text-sm	" >
                                Corriente
                            </label>
                            <input className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="checkbox"
                             //onChange={handleOnchangeDietaCorriente}
                             //defaultValue={corriente}
                             id="flexCheckDefault"/>
                        </div>
                        <div className="">
                            <label  className="form-label inline-block mb-1 text-gray-900 text-sm	" >
                                Hiposódica
                            </label>
                            <input className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="checkbox"
                            //onChange={handleOnchangeDietaHiposodica}
                             //defaultValue={hiposodica}
                             id="flexCheckDefault"/>
                        </div>
                        <div className="">
                            <label  className="form-label inline-block mb-1 text-gray-900 text-sm	" >
                                Ayuno
                            </label>
                            <input className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="checkbox"
                            //onChange={handleOnchangeDietaAyuno}
                             //defaultValue={ayuno}
                             id="flexCheckDefault"/>
                        </div>
                        <div className="">
                            <label  className="form-label inline-block mb-1 text-gray-900 text-sm	" >
                                Enema Evacuador
                            </label>
                            <input className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="checkbox" 
                            //onChange={handleOnchangeDietaEnema}
                             //defaultValue={enemaEvacuador}
                            id="flexCheckDefault"/>
                        </div>
                    </div>
                    <div className='px-0.5'>
                        <div className="">
                            <label  className="form-label inline-block mb-1 text-gray-900 text-sm	" >
                                Premedicación
                            </label>
                            <input className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="checkbox" 
                            //onChange={handleOnchangePremedicacion}
                             //defaultValue={premedicacion}
                            id="flexCheckDefault"/>
                        </div>
                        <div className="">
                            <label  className="form-label inline-block mb-1 text-gray-900 text-sm	" >
                                6 Horas Antes
                            </label>
                            <input className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="checkbox" 
                            //onChange={handleOnchangeSeisHorasAntes}
                             //defaultValue={seisHorasAntes}
                             //disabled={validacionesDisabledHoraSeis}
                            id="flexCheckDefault"/>
                        </div>
                        <div className="">
                            <label  className="form-label inline-block mb-1 text-gray-900 text-sm	" >
                                8 Horas Antes
                            </label>
                            <input className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="checkbox" 
                            //onChange={handleOnchangeOchoHorasAntes}
                             //defaultValue={ochoHorasAntes}
                             //disabled={validacionesDisabledHoraOcho}
                            id="flexCheckDefault"/>
                        </div>
                        <div className="">
                            <label  className="form-label inline-block mb-1 text-gray-900 text-sm	" >
                                12 Horas Antes
                            </label>
                            <input className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="checkbox" 
                            //onChange={handleOnchangeDoceHorasAntes}
                             //defaultValue={doceHorasAntes}
                             //disabled={validacionesDisabledHoraDoce}
                            id="flexCheckDefault"/>
                        </div>
                        <div className="">
                            <label  className="form-label inline-block mb-1 text-gray-900 text-sm	" >
                                24 Horas Antes
                            </label>
                            <input className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="checkbox" 
                            //onChange={handleOnchangeVeintiCuatroHorasAntes}
                            // defaultValue={veinteCuatroHorasAntes}
                            // disabled={validacionesDisabledHoraVeintiCuatro}
                            id="flexCheckDefault"/>
                        </div>
                        <div className="">
                            <label  className="form-label inline-block mb-1 text-gray-900 text-sm	" >
                                Acompañante
                            </label>
                            <input className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="checkbox" 
                            //onChange={handleOnchangeAcompanante}
                            // defaultValue={acompanante}
                            id="flexCheckDefault"/>
                        </div>
                        <div className="">
                            <label  className="form-label inline-block mb-1 text-gray-900 text-sm	" >
                                Rasurada
                            </label>
                            <input className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="checkbox" 
                            //onChange={handleOnchangeRasurada}
                            // defaultValue={rasurada}
                            id="flexCheckDefault"/>
                        </div>
                    </div>
                </div>
                <div className=" px-1  text-left w-1/3 ">
                    <div className=" ">
                        <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                            Palabra Clave
                        </label>
                        <input
                               //   onChange={searchUserId}
                              //defaultValue={props.userDate[0].ProEmpCod}
                              //defaultValue={edadPaciente}
                             // onFocus={cirugiaPalabraClave}
                                type="number"
                                className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                id="exampleFormControlInput1"
                                placeholder=""
                                readOnly
                                />              
                        
                        <div className='pt-2'>
                            <textarea
                           // onChange={handleOnchangeDietaTextArea}
                            //defaultValue={textAreaDieta}
                          //  value={textAreaDieta}
                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-700  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300 rounded
                                transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                            id="exampleFormControlTextarea1"
                            rows="3"
                            placeholder=""
                            ></textarea>
                        </div>
                        <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                            Obs. Quirurgicas
                        </label>
                        <div className=''>
                            <textarea
                            //onChange={handleOnchangeObsQuirurgicas}
                            //value={obsQuirurgicas}
                            //defaultValue={dataUser.ProObsT}
                            //defaultValue={dataUser.ProOBs1}
                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-700  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300 rounded
                                transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                            id="exampleFormControlTextarea1"
                            rows="3"
                            placeholder=""                            
                            ></textarea>
                        </div>
                    </div>
                </div>
                <div className=" px-1  text-left w-1/3 ">
                    <div className="">
                        <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                            Hemoderivados
                        </label>
                        <input className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" type="checkbox" id="flexCheckDefault"
                        //onChange={handleOnchangeHemoderivados}
                            //checked={hemoderivadosChe}
                        />
                    </div>
                    <div className='flex'>
                    <button className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                    //disabled={!hemoderivadosChe}
                    //onClick={cirugiaHemoderivados}
                    type='button'>^</button>
                    <div className='pl-2'>
                    <select className="form-select block  w-full px-2 py-0.5 text-base font-normal text-gray-700 bg-[#eaebec] bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    //disabled={!hemoderivadosChe}
                    // defaultValue={''}
                                            aria-label="Default select example" >
                            <option ></option>
                                           
                    </select>
                    </div>
                    
                    
                    </div>
                    
                    <div className='flex'>
                        <div>
                            <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                Cantidad
                            </label>
                            <input
                               //   onChange={searchUserId}
                              //defaultValue={props.userDate[0].ProEmpCod}
                              //disabled={!hemoderivadosChe}
                              //onChange={handleOnchangeCantidad}
                              //value={cantidadUser}
                              //defaultValue={dataUser.PROCANORD}
                                type="number"
                                className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                id="exampleFormControlInput1"
                                placeholder=""
                                />
                        </div>                        
                        <div className="pl-2">                            
                        <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                                Vol. mL
                            </label>
                            <input
                            //   onChange={searchUserId}
                            //defaultValue={props.userDate[0].ProEmpCod}
                            //onChange={handleOnchangeVolmL}
                            //disabled={!hemoderivadosChe}
                            //value={volmLUsuser}
                            //defaultValue={dataUser.PROVOLORD}
                            type="number"
                            className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                            id="exampleFormControlInput1"
                            placeholder=""
                            />
                        </div>
                    </div>
                    <label  className="form-label inline-block mb-2 text-gray-900 font-medium" >
                    Observaciones
                    </label>
                    <div className="">    
                        <textarea
                        //value={observacionesUser}
                        //onChange={handleOnchangeObservaciones}
                        //defaultValue={dataUser.ProObsHD}
                        className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-700  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300 rounded
                            transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                        id="exampleFormControlTextarea1"
                        rows="4"
                        placeholder=""
                        ></textarea>
                    </div>
                </div>
            </div> */}
        </div>
        
        <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
            <button type="button"
            onClick={handleCancelClick}
            className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
            data-bs-dismiss="modal">
            Cancelar
            </button>
            <button type="submit"
            //onClick={handleClickDataCirugia}
            className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
            Guardar
            </button>
        </div>
        </form>
        </div>
        {/* <div className="flex-auto overflow-y-auto relative ">
        <div className={openTab === 2 ? "block" : "hidden"} id="link2">        
            <ModalProcedimiento idCirugia = {user.ProCirCod} user={user} passDataActualizaTablaPacientes={passDataActualizaTablaPacientes}/>     
                  
        </div>
        </div> */}
        {/* </>
)}  */}

        </div>
            
    </div>
    {/* {
                              loading?
                              null:
                              <div className="relative flex items-center justify-center h-screen">
            <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-slate-900 bg-opacity-25" style={{ pointerEvents: "auto" }}>
                <div className="flex flex-col items-center justify-center p-6 bg-white rounded shadow-lg">
                    <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
                    <p className="mt-4 text-lg">Cargando</p>
                </div>
            </div>
            <div className="absolute top-0 left-0 w-full h-full" style={{ pointerEvents: "none" }}></div>
        </div>
                            }        */}
        </div>
        
        
    </>
  )
}

export default ModalDiligenciarRecordAnestesia